import * as wrapActions from "./wrap-actions"

export default function EditorAutosuggestOAS3KeywordsPlugin() {
  return {
    statePlugins: {
      editor: {
        wrapActions,
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/editor-autosuggest-oas3-keywords/index.js